export enum EToastUsage {
  RESEND = 'resend',
  VERIFIED = 'verified',
  IMAGE_GENERATED = 'image_generated',
  IMAGE_GENERATING = 'image_generating',
  IMAGE_GENERATION_FAILED = 'image_generation_failed',
  IMAGE_GENERATION_ERROR = 'image_generation_error',
  CONTENT_UNLOCKED = 'content_unlocked'
}

export enum EToastType {
  SUCCESS = 'success',
  FAIL = 'fail',
  ERROR = 'error',
  WARN = 'warn',
  INFO = 'info',
  ERROR_RED = 'error_red'
}

export enum EToastPosition {
  TOP = 'top',
  BOTTOM = 'bottom'
}

export enum EToastButtonTitle {
  TRY_AGAIN = 'Try again',
  CONTACT_SUPPORT = 'Contact support',
  REFRESH_NOW = 'Refresh now',
  ENABLE_ACCESS = 'Enable access'
}
